import { default as accept_45invitehdd5wQeCCQMeta } from "/vercel/path0/v3/pages/accept-invite.vue?macro=true";
import { default as index_45oldY5fWKN3OAoMeta } from "/vercel/path0/v3/pages/access/index-old.vue?macro=true";
import { default as not_45found_oldAnlO19eSz3Meta } from "/vercel/path0/v3/pages/access/not-found_old.vue?macro=true";
import { default as indexyLfGdix5N6Meta } from "/vercel/path0/v3/pages/admin/activities/index.vue?macro=true";
import { default as indexqIf4o8fa0JMeta } from "/vercel/path0/v3/pages/admin/audit-log/index.vue?macro=true";
import { default as indexg9Z1erM0ZXMeta } from "/vercel/path0/v3/pages/admin/data-transformation/index.vue?macro=true";
import { default as _91efid_93ffQ0yp2llDMeta } from "/vercel/path0/v3/pages/admin/emission-factors/edit/[efid].vue?macro=true";
import { default as indexjhu5I10LhhMeta } from "/vercel/path0/v3/pages/admin/emission-factors/index.vue?macro=true";
import { default as indexUUorP4SDhAMeta } from "/vercel/path0/v3/pages/admin/ghg-templates/index.vue?macro=true";
import { default as indexSMIWpwdILKMeta } from "/vercel/path0/v3/pages/admin/groups/index.vue?macro=true";
import { default as home8xcIFJ89zNMeta } from "/vercel/path0/v3/pages/admin/home.vue?macro=true";
import { default as createBdMYuzaA7TMeta } from "/vercel/path0/v3/pages/admin/pollutants/create.vue?macro=true";
import { default as _91shortcode_93pMF34rpYm7Meta } from "/vercel/path0/v3/pages/admin/pollutants/edit/[shortcode].vue?macro=true";
import { default as indexg1QHAb8HSCMeta } from "/vercel/path0/v3/pages/admin/pollutants/index.vue?macro=true";
import { default as indexoE2vsGuov2Meta } from "/vercel/path0/v3/pages/admin/question-bank/index.vue?macro=true";
import { default as _91id_937NBWJTVR6GMeta } from "/vercel/path0/v3/pages/admin/question-bank/sections/[id].vue?macro=true";
import { default as _91id_93nO3ZBsV0GDMeta } from "/vercel/path0/v3/pages/admin/question-builder/edit/[id].vue?macro=true";
import { default as indexE0Kqq4Zd9pMeta } from "/vercel/path0/v3/pages/admin/question-builder/index.vue?macro=true";
import { default as indexMoh1SDdi4iMeta } from "/vercel/path0/v3/pages/admin/regions/index.vue?macro=true";
import { default as create4sxHl5D9HeMeta } from "/vercel/path0/v3/pages/admin/reporting-frameworks/create.vue?macro=true";
import { default as _91id_93s3ocOpjiW8Meta } from "/vercel/path0/v3/pages/admin/reporting-frameworks/edit/[id].vue?macro=true";
import { default as index8tIXxZknzCMeta } from "/vercel/path0/v3/pages/admin/reporting-frameworks/index.vue?macro=true";
import { default as managefbZgamPGn2Meta } from "/vercel/path0/v3/pages/admin/reporting-frameworks/manage.vue?macro=true";
import { default as indexcmHZZ5oA8HMeta } from "/vercel/path0/v3/pages/admin/settings/add-admins/index.vue?macro=true";
import { default as indexXwFXjEOueeMeta } from "/vercel/path0/v3/pages/admin/settings/invite-engineers/index.vue?macro=true";
import { default as indexMC5hB9bHeqMeta } from "/vercel/path0/v3/pages/admin/sources/index.vue?macro=true";
import { default as create_45type_45scopeyON4uPOAdTMeta } from "/vercel/path0/v3/pages/admin/types/create-type-scope.vue?macro=true";
import { default as _91id_93eAwFM9WYo2Meta } from "/vercel/path0/v3/pages/admin/types/edit-prompts/[id].vue?macro=true";
import { default as _91id_93XmidVKJfBwMeta } from "/vercel/path0/v3/pages/admin/types/edit/[id].vue?macro=true";
import { default as indexc7vOaIsSUGMeta } from "/vercel/path0/v3/pages/admin/types/index.vue?macro=true";
import { default as _91id_93glczDu7HUkMeta } from "/vercel/path0/v3/pages/admin/types/prompts/[id].vue?macro=true";
import { default as create3uMS1KRc8ZMeta } from "/vercel/path0/v3/pages/admin/units/create.vue?macro=true";
import { default as indexJeTO72bW5gMeta } from "/vercel/path0/v3/pages/admin/units/index.vue?macro=true";
import { default as _91id_93LKY5VMd42rMeta } from "/vercel/path0/v3/pages/admin/units/measurement/[id].vue?macro=true";
import { default as createEZxhjaBzH7Meta } from "/vercel/path0/v3/pages/company/create.vue?macro=true";
import { default as contact_45uslyga9TazAhMeta } from "/vercel/path0/v3/pages/contact-us.vue?macro=true";
import { default as indexWpttpGokl4Meta } from "/vercel/path0/v3/pages/dashboard/abatement/index.vue?macro=true";
import { default as indexwD93hdcPaEMeta } from "/vercel/path0/v3/pages/dashboard/assets/index.vue?macro=true";
import { default as indexP8NFhOlhsTMeta } from "/vercel/path0/v3/pages/dashboard/assignments/index.vue?macro=true";
import { default as ghg_45overview6JAh1aLRkjMeta } from "/vercel/path0/v3/pages/dashboard/coming-soon/ghg-overview.vue?macro=true";
import { default as _91id_93nqxmTo36PeMeta } from "/vercel/path0/v3/pages/dashboard/companies/company/[id].vue?macro=true";
import { default as indexZugjfn6G2dMeta } from "/vercel/path0/v3/pages/dashboard/companies/index.vue?macro=true";
import { default as _91id_93Zp0SYIczjHMeta } from "/vercel/path0/v3/pages/dashboard/companies/labels/edit/[id].vue?macro=true";
import { default as indexocIJUBM0g8Meta } from "/vercel/path0/v3/pages/dashboard/companies/labels/index.vue?macro=true";
import { default as _91id_93GLvisuWpl8Meta } from "/vercel/path0/v3/pages/dashboard/companies/locations/edit/[id].vue?macro=true";
import { default as indexiMTDHpkIxNMeta } from "/vercel/path0/v3/pages/dashboard/companies/locations/index.vue?macro=true";
import { default as pollutantslVbHMcOzQtMeta } from "/vercel/path0/v3/pages/dashboard/companies/pollutants.vue?macro=true";
import { default as create3zG693XIBHMeta } from "/vercel/path0/v3/pages/dashboard/companies/sources/create.vue?macro=true";
import { default as _91id_93jADa9oE7qaMeta } from "/vercel/path0/v3/pages/dashboard/companies/sources/edit/[id].vue?macro=true";
import { default as indexy5RQeavKDwMeta } from "/vercel/path0/v3/pages/dashboard/companies/sources/index.vue?macro=true";
import { default as indexE5wLmYObVjMeta } from "/vercel/path0/v3/pages/dashboard/data-assignment/index.vue?macro=true";
import { default as _91metricId_93nrpiBWEcfIMeta } from "/vercel/path0/v3/pages/dashboard/data-entry/esg-data-entry/[metricId].vue?macro=true";
import { default as _91metricId_93y9zMXFPIwIMeta } from "/vercel/path0/v3/pages/dashboard/data-entry/esg-data-entry/approval/[metricId].vue?macro=true";
import { default as indexKUCGLOtvYYMeta } from "/vercel/path0/v3/pages/dashboard/data-entry/esg-data-entry/index.vue?macro=true";
import { default as _91categoryId_93UHp03M9Z2UMeta } from "/vercel/path0/v3/pages/dashboard/data-upload/[categoryId].vue?macro=true";
import { default as indexS3TrFAqclGMeta } from "/vercel/path0/v3/pages/dashboard/data-upload/index.vue?macro=true";
import { default as _91id_93DZoToD9NvTMeta } from "/vercel/path0/v3/pages/dashboard/data-upload/preview/[id].vue?macro=true";
import { default as _91id_93uhcAJXuA1oMeta } from "/vercel/path0/v3/pages/dashboard/data-upload/review/[id].vue?macro=true";
import { default as submissionsIKV45MaBfrMeta } from "/vercel/path0/v3/pages/dashboard/data-upload/submissions.vue?macro=true";
import { default as indexXAGmrvKNUOMeta } from "/vercel/path0/v3/pages/dashboard/emission-audit-log/index.vue?macro=true";
import { default as _91sourceType_93bkFM0NG9pjMeta } from "/vercel/path0/v3/pages/dashboard/emission-sources/[sourceType].vue?macro=true";
import { default as createJWcjQV4HhPMeta } from "/vercel/path0/v3/pages/dashboard/emission-sources/create.vue?macro=true";
import { default as _91id_931ZdQ7oV4mmMeta } from "/vercel/path0/v3/pages/dashboard/emission-sources/edit/[id].vue?macro=true";
import { default as indexjoBK8QAIeMMeta } from "/vercel/path0/v3/pages/dashboard/emission-sources/index.vue?macro=true";
import { default as rest_45apiXrXicNnok5Meta } from "/vercel/path0/v3/pages/dashboard/emission-sources/integrations/rest-api.vue?macro=true";
import { default as _91id_93lwM488rioJMeta } from "/vercel/path0/v3/pages/dashboard/emission-sources/labels/edit/[id].vue?macro=true";
import { default as indexWkCBVoFiWkMeta } from "/vercel/path0/v3/pages/dashboard/emission-sources/labels/index.vue?macro=true";
import { default as index65KL3yw820Meta } from "/vercel/path0/v3/pages/dashboard/esg-data-entry/index.vue?macro=true";
import { default as _91id_93eKd51fgkAJMeta } from "/vercel/path0/v3/pages/dashboard/esg-data-entry/manual/[id].vue?macro=true";
import { default as _91id_93lxEqp6dwAcMeta } from "/vercel/path0/v3/pages/dashboard/esg-data-entry/preview/[id].vue?macro=true";
import { default as _91id_932YD0B2IGEoMeta } from "/vercel/path0/v3/pages/dashboard/esg-data-entry/upload/[id].vue?macro=true";
import { default as editVo1DPsUvz9Meta } from "/vercel/path0/v3/pages/dashboard/esg-data-submission/[id]/edit.vue?macro=true";
import { default as reviewuiB2H5wuHXMeta } from "/vercel/path0/v3/pages/dashboard/esg-data-submission/[id]/review.vue?macro=true";
import { default as viewETS2jjUM4cMeta } from "/vercel/path0/v3/pages/dashboard/esg-data-submission/[id]/view.vue?macro=true";
import { default as indexrKLJArJL2XMeta } from "/vercel/path0/v3/pages/dashboard/esg-data-submission/index.vue?macro=true";
import { default as _91id_93bd5Bbfb3f8Meta } from "/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/edit/[id].vue?macro=true";
import { default as index2KT2PhQOv2Meta } from "/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/export/index.vue?macro=true";
import { default as indexrn3y0sSwJ3Meta } from "/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/index.vue?macro=true";
import { default as _91id_93ZCBhOFvT5EMeta } from "/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/preview/[id].vue?macro=true";
import { default as index7VeWAkV391Meta } from "/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/select-metrics/index.vue?macro=true";
import { default as assignH8DjCHADpWMeta } from "/vercel/path0/v3/pages/dashboard/esg-metrics/assign.vue?macro=true";
import { default as indexMBQBH7nizMMeta } from "/vercel/path0/v3/pages/dashboard/esg-metrics/index.vue?macro=true";
import { default as indexj4Lmtz6z8hMeta } from "/vercel/path0/v3/pages/dashboard/ghg-approval/index.vue?macro=true";
import { default as indexFOWLJTWQ5CMeta } from "/vercel/path0/v3/pages/dashboard/ghg-emission-factor-configuration/[categoryId]/index.vue?macro=true";
import { default as indexm11iW7o5lfMeta } from "/vercel/path0/v3/pages/dashboard/ghg-emission-factor-configuration/index.vue?macro=true";
import { default as historical_45dataDzoEO6AohBMeta } from "/vercel/path0/v3/pages/dashboard/ghg-overview/historical-data.vue?macro=true";
import { default as indexEXtPQm7Ed4Meta } from "/vercel/path0/v3/pages/dashboard/ghg-overview/index.vue?macro=true";
import { default as ghg_45progress_45trackerrqaYmBw56cMeta } from "/vercel/path0/v3/pages/dashboard/ghg-progress-tracker.vue?macro=true";
import { default as home_45oldEEs0SUV8JqMeta } from "/vercel/path0/v3/pages/dashboard/home-old.vue?macro=true";
import { default as customScoKhBisVxMeta } from "/vercel/path0/v3/pages/dashboard/home/custom.vue?macro=true";
import { default as esgttX0hv7UkTMeta } from "/vercel/path0/v3/pages/dashboard/home/esg.vue?macro=true";
import { default as index76eGskwKQ1Meta } from "/vercel/path0/v3/pages/dashboard/home/index.vue?macro=true";
import { default as _91id_93P4gYCzFUk1Meta } from "/vercel/path0/v3/pages/dashboard/marketplace/[id].vue?macro=true";
import { default as indexraEEiSwSdwMeta } from "/vercel/path0/v3/pages/dashboard/marketplace/index.vue?macro=true";
import { default as reporting_45frameworksSxAcwtOi1IMeta } from "/vercel/path0/v3/pages/dashboard/reporting-frameworks.vue?macro=true";
import { default as indexrdCZuC8VhSMeta } from "/vercel/path0/v3/pages/dashboard/reporting/amoq/index.vue?macro=true";
import { default as generated_45reportXyqBNrsQGtMeta } from "/vercel/path0/v3/pages/dashboard/reporting/generated-report.vue?macro=true";
import { default as preview_45reportApE0Wuncn3Meta } from "/vercel/path0/v3/pages/dashboard/reporting/preview-report.vue?macro=true";
import { default as quantitative_45reportQ51W2N1t8YMeta } from "/vercel/path0/v3/pages/dashboard/reporting/quantitative-report.vue?macro=true";
import { default as report_45frameworksTM8PuL6pX3Meta } from "/vercel/path0/v3/pages/dashboard/reporting/report-frameworks.vue?macro=true";
import { default as generalN7LZbOvM3OMeta } from "/vercel/path0/v3/pages/dashboard/settings/general.vue?macro=true";
import { default as integration4fxeNo44TmMeta } from "/vercel/path0/v3/pages/dashboard/settings/integration.vue?macro=true";
import { default as manage_45usersfuUxdFZZvtMeta } from "/vercel/path0/v3/pages/dashboard/settings/manage-users.vue?macro=true";
import { default as permissions66pR2FTQluMeta } from "/vercel/path0/v3/pages/dashboard/settings/permissions.vue?macro=true";
import { default as tierK2pGswoKevMeta } from "/vercel/path0/v3/pages/dashboard/settings/tier.vue?macro=true";
import { default as usersZbhdcQPQnYMeta } from "/vercel/path0/v3/pages/dashboard/settings/users.vue?macro=true";
import { default as data_45handlingPU0rJFGBDNMeta } from "/vercel/path0/v3/pages/data-handling.vue?macro=true";
import { default as ErrorPermissionxjDvMeisRdMeta } from "/vercel/path0/v3/pages/errors/ErrorPermission.vue?macro=true";
import { default as ErrorSubscriptionYyl8XiDeB0Meta } from "/vercel/path0/v3/pages/errors/ErrorSubscription.vue?macro=true";
import { default as ErrorSubscriptionExpiredwc2pY2pCFVMeta } from "/vercel/path0/v3/pages/errors/ErrorSubscriptionExpired.vue?macro=true";
import { default as indexsTUPWspFUNMeta } from "/vercel/path0/v3/pages/index.vue?macro=true";
import { default as _91key_93XGxWxXJqiUMeta } from "/vercel/path0/v3/pages/invitations/accept-invite/[key].vue?macro=true";
import { default as login_45oldSghTZIsvWpMeta } from "/vercel/path0/v3/pages/login-old.vue?macro=true";
import { default as loginxY1wJnEVbEMeta } from "/vercel/path0/v3/pages/login.vue?macro=true";
import { default as not_45foundT1JIqJqwiTMeta } from "/vercel/path0/v3/pages/not-found.vue?macro=true";
import { default as forgotU1PkwIZ0d0Meta } from "/vercel/path0/v3/pages/password/forgot.vue?macro=true";
import { default as register_oldAnPfsBZWdaMeta } from "/vercel/path0/v3/pages/register_old.vue?macro=true";
import { default as registerGuBNcVABfCMeta } from "/vercel/path0/v3/pages/register.vue?macro=true";
import { default as _91id_93TOiWmtN4CFMeta } from "/vercel/path0/v3/pages/reports/generate/[id].vue?macro=true";
import { default as _91id_932TToJAzhc8Meta } from "/vercel/path0/v3/pages/reports/view/[id].vue?macro=true";
import { default as _91token_93ATDY3sFNNuMeta } from "/vercel/path0/v3/pages/reset/[uid]/[token].vue?macro=true";
import { default as successYtwd5j2c6gMeta } from "/vercel/path0/v3/pages/success.vue?macro=true";
import { default as index46miWyRjCWMeta } from "/vercel/path0/v3/pages/superadmin/home/index.vue?macro=true";
import { default as createh6XM8uvMF6Meta } from "/vercel/path0/v3/pages/superadmin/tiers/create.vue?macro=true";
import { default as _91id_93DuGBqi6nBaMeta } from "/vercel/path0/v3/pages/superadmin/tiers/edit/[id].vue?macro=true";
import { default as indexrnD6xX9RrJMeta } from "/vercel/path0/v3/pages/superadmin/tiers/index.vue?macro=true";
import { default as _91id_93qrR9epJd6lMeta } from "/vercel/path0/v3/pages/superadmin/trials/edit/[id].vue?macro=true";
import { default as indexcYZPvTIQuLMeta } from "/vercel/path0/v3/pages/superadmin/trials/index.vue?macro=true";
import { default as verification_45pendingUoHZUEltcpMeta } from "/vercel/path0/v3/pages/verification-pending.vue?macro=true";
export default [
  {
    name: "AcceptInvitePage",
    path: "/accept-invite",
    meta: accept_45invitehdd5wQeCCQMeta || {},
    component: () => import("/vercel/path0/v3/pages/accept-invite.vue").then(m => m.default || m)
  },
  {
    name: "AccessPage",
    path: "/access/index-old",
    meta: index_45oldY5fWKN3OAoMeta || {},
    component: () => import("/vercel/path0/v3/pages/access/index-old.vue").then(m => m.default || m)
  },
  {
    name: "access-not-found_old",
    path: "/access/not-found_old",
    component: () => import("/vercel/path0/v3/pages/access/not-found_old.vue").then(m => m.default || m)
  },
  {
    name: "AdminActivitiesPage",
    path: "/admin/activities",
    meta: indexyLfGdix5N6Meta || {},
    component: () => import("/vercel/path0/v3/pages/admin/activities/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: indexqIf4o8fa0JMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/audit-log/index.vue").then(m => m.default || m)
  },
  {
    name: "DataTransformationPage",
    path: "/admin/data-transformation",
    meta: indexg9Z1erM0ZXMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/data-transformation/index.vue").then(m => m.default || m)
  },
  {
    name: "EditEmissionFactors",
    path: "/admin/emission-factors/edit/:efid()",
    meta: _91efid_93ffQ0yp2llDMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/emission-factors/edit/[efid].vue").then(m => m.default || m)
  },
  {
    name: "EmissionFactors",
    path: "/admin/emission-factors",
    meta: indexjhu5I10LhhMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/emission-factors/index.vue").then(m => m.default || m)
  },
  {
    name: "AdminGhgTemplates",
    path: "/admin/ghg-templates",
    meta: indexUUorP4SDhAMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/ghg-templates/index.vue").then(m => m.default || m)
  },
  {
    name: "AdminGroupsPage",
    path: "/admin/groups",
    meta: indexSMIWpwdILKMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/groups/index.vue").then(m => m.default || m)
  },
  {
    name: "AdminHomePage",
    path: "/admin/home",
    meta: home8xcIFJ89zNMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/home.vue").then(m => m.default || m)
  },
  {
    name: "CreatePollutantPage",
    path: "/admin/pollutants/create",
    meta: createBdMYuzaA7TMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/pollutants/create.vue").then(m => m.default || m)
  },
  {
    name: "admin-pollutants-edit-shortcode",
    path: "/admin/pollutants/edit/:shortcode()",
    meta: _91shortcode_93pMF34rpYm7Meta || {},
    component: () => import("/vercel/path0/v3/pages/admin/pollutants/edit/[shortcode].vue").then(m => m.default || m)
  },
  {
    name: "PollutantPage",
    path: "/admin/pollutants",
    meta: indexg1QHAb8HSCMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/pollutants/index.vue").then(m => m.default || m)
  },
  {
    name: "QuestionBankPage",
    path: "/admin/question-bank",
    meta: indexoE2vsGuov2Meta || {},
    component: () => import("/vercel/path0/v3/pages/admin/question-bank/index.vue").then(m => m.default || m)
  },
  {
    name: "EditPollutantPage",
    path: "/admin/question-bank/sections/:id()",
    meta: _91id_937NBWJTVR6GMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/question-bank/sections/[id].vue").then(m => m.default || m)
  },
  {
    name: "EditQuestionBuilderPage",
    path: "/admin/question-builder/edit/:id()",
    meta: _91id_93nO3ZBsV0GDMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/question-builder/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "QuestionBuilderPage",
    path: "/admin/question-builder",
    meta: indexE0Kqq4Zd9pMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/question-builder/index.vue").then(m => m.default || m)
  },
  {
    name: "AdminRegionsPage",
    path: "/admin/regions",
    meta: indexMoh1SDdi4iMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/regions/index.vue").then(m => m.default || m)
  },
  {
    name: "CreateReportingFrameworksPage",
    path: "/admin/reporting-frameworks/create",
    meta: create4sxHl5D9HeMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/reporting-frameworks/create.vue").then(m => m.default || m)
  },
  {
    name: "EditReportingFrameworksPage",
    path: "/admin/reporting-frameworks/edit/:id()",
    meta: _91id_93s3ocOpjiW8Meta || {},
    component: () => import("/vercel/path0/v3/pages/admin/reporting-frameworks/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "ReportingFrameworksPage",
    path: "/admin/reporting-frameworks",
    meta: index8tIXxZknzCMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/reporting-frameworks/index.vue").then(m => m.default || m)
  },
  {
    name: "ManageFrameworksPage",
    path: "/admin/reporting-frameworks/manage",
    meta: managefbZgamPGn2Meta || {},
    component: () => import("/vercel/path0/v3/pages/admin/reporting-frameworks/manage.vue").then(m => m.default || m)
  },
  {
    name: "SettingsAdminPage",
    path: "/admin/settings/add-admins",
    meta: indexcmHZZ5oA8HMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/settings/add-admins/index.vue").then(m => m.default || m)
  },
  {
    name: "SettingsInvitePage",
    path: "/admin/settings/invite-engineers",
    meta: indexXwFXjEOueeMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/settings/invite-engineers/index.vue").then(m => m.default || m)
  },
  {
    name: "AdminSourcesPage",
    path: "/admin/sources",
    meta: indexMC5hB9bHeqMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/sources/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-types-create-type-scope",
    path: "/admin/types/create-type-scope",
    meta: create_45type_45scopeyON4uPOAdTMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/types/create-type-scope.vue").then(m => m.default || m)
  },
  {
    name: "admin-types-edit-prompts-id",
    path: "/admin/types/edit-prompts/:id()",
    meta: _91id_93eAwFM9WYo2Meta || {},
    component: () => import("/vercel/path0/v3/pages/admin/types/edit-prompts/[id].vue").then(m => m.default || m)
  },
  {
    name: "EditTypePage",
    path: "/admin/types/edit/:id()",
    meta: _91id_93XmidVKJfBwMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/types/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "AdminScopesPage",
    path: "/admin/types",
    meta: indexc7vOaIsSUGMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/types/index.vue").then(m => m.default || m)
  },
  {
    name: "CreatePromptsPage",
    path: "/admin/types/prompts/:id()",
    meta: _91id_93glczDu7HUkMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/types/prompts/[id].vue").then(m => m.default || m)
  },
  {
    name: "CreateMeasurement",
    path: "/admin/units/create",
    meta: create3uMS1KRc8ZMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/units/create.vue").then(m => m.default || m)
  },
  {
    name: "UnitsMeasurementsPage",
    path: "/admin/units",
    meta: indexJeTO72bW5gMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/units/index.vue").then(m => m.default || m)
  },
  {
    name: "ConversionPage",
    path: "/admin/units/measurement/:id()",
    meta: _91id_93LKY5VMd42rMeta || {},
    component: () => import("/vercel/path0/v3/pages/admin/units/measurement/[id].vue").then(m => m.default || m)
  },
  {
    name: "CreateCompanyPage",
    path: "/company/create",
    meta: createEZxhjaBzH7Meta || {},
    component: () => import("/vercel/path0/v3/pages/company/create.vue").then(m => m.default || m)
  },
  {
    name: "ContactUsPage",
    path: "/contact-us",
    meta: contact_45uslyga9TazAhMeta || {},
    component: () => import("/vercel/path0/v3/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: "AbatementPage",
    path: "/dashboard/abatement",
    meta: indexWpttpGokl4Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/abatement/index.vue").then(m => m.default || m)
  },
  {
    name: "AssetsPage",
    path: "/dashboard/assets",
    meta: indexwD93hdcPaEMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/assets/index.vue").then(m => m.default || m)
  },
  {
    name: "My Assigments",
    path: "/dashboard/assignments",
    meta: indexP8NFhOlhsTMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/assignments/index.vue").then(m => m.default || m)
  },
  {
    name: "GhgOverview",
    path: "/dashboard/coming-soon/ghg-overview",
    meta: ghg_45overview6JAh1aLRkjMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/coming-soon/ghg-overview.vue").then(m => m.default || m)
  },
  {
    name: "CompanyProfilePage",
    path: "/dashboard/companies/company/:id()",
    meta: _91id_93nqxmTo36PeMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/company/[id].vue").then(m => m.default || m)
  },
  {
    name: "CompaniesPage",
    path: "/dashboard/companies",
    meta: indexZugjfn6G2dMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/index.vue").then(m => m.default || m)
  },
  {
    name: "EditLabel",
    path: "/dashboard/companies/labels/edit/:id()",
    meta: _91id_93Zp0SYIczjHMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/labels/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "LabelsPage",
    path: "/dashboard/companies/labels",
    meta: indexocIJUBM0g8Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/labels/index.vue").then(m => m.default || m)
  },
  {
    name: "EditLocation",
    path: "/dashboard/companies/locations/edit/:id()",
    meta: _91id_93GLvisuWpl8Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/locations/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "LocationsPage",
    path: "/dashboard/companies/locations",
    meta: indexiMTDHpkIxNMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/locations/index.vue").then(m => m.default || m)
  },
  {
    name: "PollutantConfigurationPage",
    path: "/dashboard/companies/pollutants",
    meta: pollutantslVbHMcOzQtMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/pollutants.vue").then(m => m.default || m)
  },
  {
    name: "dashboard-companies-sources-create",
    path: "/dashboard/companies/sources/create",
    meta: create3zG693XIBHMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/sources/create.vue").then(m => m.default || m)
  },
  {
    name: "CreateSource",
    path: "/dashboard/companies/sources/edit/:id()",
    meta: _91id_93jADa9oE7qaMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/sources/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "SourcesPage",
    path: "/dashboard/companies/sources",
    meta: indexy5RQeavKDwMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/companies/sources/index.vue").then(m => m.default || m)
  },
  {
    name: "DataAssignments",
    path: "/dashboard/data-assignment",
    meta: indexE5wLmYObVjMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-assignment/index.vue").then(m => m.default || m)
  },
  {
    name: "UploadDataByMetricPage",
    path: "/dashboard/data-entry/esg-data-entry/:metricId()",
    meta: _91metricId_93nrpiBWEcfIMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-entry/esg-data-entry/[metricId].vue").then(m => m.default || m)
  },
  {
    name: "ApproveDataByMetricPage",
    path: "/dashboard/data-entry/esg-data-entry/approval/:metricId()",
    meta: _91metricId_93y9zMXFPIwIMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-entry/esg-data-entry/approval/[metricId].vue").then(m => m.default || m)
  },
  {
    name: "EsgDataUploadPage",
    path: "/dashboard/data-entry/esg-data-entry",
    meta: indexKUCGLOtvYYMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-entry/esg-data-entry/index.vue").then(m => m.default || m)
  },
  {
    name: "UploadDataByCategoryPage",
    path: "/dashboard/data-upload/:categoryId()",
    meta: _91categoryId_93UHp03M9Z2UMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-upload/[categoryId].vue").then(m => m.default || m)
  },
  {
    name: "EmissionDataCategories",
    path: "/dashboard/data-upload",
    meta: indexS3TrFAqclGMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-upload/index.vue").then(m => m.default || m)
  },
  {
    name: "DataUploadPreviewPage",
    path: "/dashboard/data-upload/preview/:id()",
    meta: _91id_93DZoToD9NvTMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-upload/preview/[id].vue").then(m => m.default || m)
  },
  {
    name: "ReviewUploadDataByCategoryPage",
    path: "/dashboard/data-upload/review/:id()",
    meta: _91id_93uhcAJXuA1oMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-upload/review/[id].vue").then(m => m.default || m)
  },
  {
    name: "GHGSubmissions",
    path: "/dashboard/data-upload/submissions",
    meta: submissionsIKV45MaBfrMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/data-upload/submissions.vue").then(m => m.default || m)
  },
  {
    name: "EmissionAuditLogPage",
    path: "/dashboard/emission-audit-log",
    meta: indexXAGmrvKNUOMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-audit-log/index.vue").then(m => m.default || m)
  },
  {
    name: "EmissionsDataEntryPage",
    path: "/dashboard/emission-sources/:sourceType()",
    meta: _91sourceType_93bkFM0NG9pjMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/[sourceType].vue").then(m => m.default || m)
  },
  {
    name: "CreateSource",
    path: "/dashboard/emission-sources/create",
    meta: createJWcjQV4HhPMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/create.vue").then(m => m.default || m)
  },
  {
    name: "EditSource",
    path: "/dashboard/emission-sources/edit/:id()",
    meta: _91id_931ZdQ7oV4mmMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "EmissionSourcePage",
    path: "/dashboard/emission-sources",
    meta: indexjoBK8QAIeMMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/index.vue").then(m => m.default || m)
  },
  {
    name: "RestApiIntegrationPage",
    path: "/dashboard/emission-sources/integrations/rest-api",
    meta: rest_45apiXrXicNnok5Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/integrations/rest-api.vue").then(m => m.default || m)
  },
  {
    name: "EditLabel",
    path: "/dashboard/emission-sources/labels/edit/:id()",
    meta: _91id_93lwM488rioJMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/labels/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "LabelsPage",
    path: "/dashboard/emission-sources/labels",
    meta: indexWkCBVoFiWkMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/emission-sources/labels/index.vue").then(m => m.default || m)
  },
  {
    name: "EsgDataEntryPage",
    path: "/dashboard/esg-data-entry",
    meta: index65KL3yw820Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-entry/index.vue").then(m => m.default || m)
  },
  {
    name: "EsgDataEntryManualInput",
    path: "/dashboard/esg-data-entry/manual/:id()",
    meta: _91id_93eKd51fgkAJMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-entry/manual/[id].vue").then(m => m.default || m)
  },
  {
    name: "EsgDataEntryPreview",
    path: "/dashboard/esg-data-entry/preview/:id()",
    meta: _91id_93lxEqp6dwAcMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-entry/preview/[id].vue").then(m => m.default || m)
  },
  {
    name: "EsgDataEntryUpload",
    path: "/dashboard/esg-data-entry/upload/:id()",
    meta: _91id_932YD0B2IGEoMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-entry/upload/[id].vue").then(m => m.default || m)
  },
  {
    name: "EditEsgDataSubmissionPage",
    path: "/dashboard/esg-data-submission/:id()/edit",
    meta: editVo1DPsUvz9Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-submission/[id]/edit.vue").then(m => m.default || m)
  },
  {
    name: "EsgDataSubmissionApprovalPage",
    path: "/dashboard/esg-data-submission/:id()/review",
    meta: reviewuiB2H5wuHXMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-submission/[id]/review.vue").then(m => m.default || m)
  },
  {
    name: "ExpandEsgDataSubmissionPage",
    path: "/dashboard/esg-data-submission/:id()/view",
    meta: viewETS2jjUM4cMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-submission/[id]/view.vue").then(m => m.default || m)
  },
  {
    name: "EsgDataSubmissionPage",
    path: "/dashboard/esg-data-submission",
    meta: indexrKLJArJL2XMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-data-submission/index.vue").then(m => m.default || m)
  },
  {
    name: "EsgMetricsEditPage",
    path: "/dashboard/esg-metrics-configuration/edit/:id()",
    meta: _91id_93bd5Bbfb3f8Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "dashboard-esg-metrics-configuration-export",
    path: "/dashboard/esg-metrics-configuration/export",
    meta: index2KT2PhQOv2Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/export/index.vue").then(m => m.default || m)
  },
  {
    name: "EsgMetricsConfigurationPage",
    path: "/dashboard/esg-metrics-configuration",
    meta: indexrn3y0sSwJ3Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/index.vue").then(m => m.default || m)
  },
  {
    name: "EsgMetricsPreviewPage",
    path: "/dashboard/esg-metrics-configuration/preview/:id()",
    meta: _91id_93ZCBhOFvT5EMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/preview/[id].vue").then(m => m.default || m)
  },
  {
    name: "EsgMetricsSelectionPage",
    path: "/dashboard/esg-metrics-configuration/select-metrics",
    meta: index7VeWAkV391Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics-configuration/select-metrics/index.vue").then(m => m.default || m)
  },
  {
    name: "EsgAssignMetricsPage",
    path: "/dashboard/esg-metrics/assign",
    meta: assignH8DjCHADpWMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics/assign.vue").then(m => m.default || m)
  },
  {
    name: "EsgDataManagementPage",
    path: "/dashboard/esg-metrics",
    meta: indexMBQBH7nizMMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/esg-metrics/index.vue").then(m => m.default || m)
  },
  {
    name: "GHGApprovalHome",
    path: "/dashboard/ghg-approval",
    meta: indexj4Lmtz6z8hMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/ghg-approval/index.vue").then(m => m.default || m)
  },
  {
    name: "GhgEmissionFactorCategoryPage",
    path: "/dashboard/ghg-emission-factor-configuration/:categoryId()",
    meta: indexFOWLJTWQ5CMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/ghg-emission-factor-configuration/[categoryId]/index.vue").then(m => m.default || m)
  },
  {
    name: "GhgEmissionFactorConfigurationPage",
    path: "/dashboard/ghg-emission-factor-configuration",
    meta: indexm11iW7o5lfMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/ghg-emission-factor-configuration/index.vue").then(m => m.default || m)
  },
  {
    name: "HistoricalData",
    path: "/dashboard/ghg-overview/historical-data",
    meta: historical_45dataDzoEO6AohBMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/ghg-overview/historical-data.vue").then(m => m.default || m)
  },
  {
    name: "GhgOverview",
    path: "/dashboard/ghg-overview",
    meta: indexEXtPQm7Ed4Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/ghg-overview/index.vue").then(m => m.default || m)
  },
  {
    name: "GhgProgressTracker",
    path: "/dashboard/ghg-progress-tracker",
    meta: ghg_45progress_45trackerrqaYmBw56cMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/ghg-progress-tracker.vue").then(m => m.default || m)
  },
  {
    name: "DashboardOldHomePage",
    path: "/dashboard/home-old",
    meta: home_45oldEEs0SUV8JqMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/home-old.vue").then(m => m.default || m)
  },
  {
    name: "DashboardCustomPage",
    path: "/dashboard/home/custom",
    meta: customScoKhBisVxMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/home/custom.vue").then(m => m.default || m)
  },
  {
    name: "DashboardEsgPage",
    path: "/dashboard/home/esg",
    meta: esgttX0hv7UkTMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/home/esg.vue").then(m => m.default || m)
  },
  {
    name: "DashboardGhgPage",
    path: "/dashboard/home",
    meta: index76eGskwKQ1Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/home/index.vue").then(m => m.default || m)
  },
  {
    name: "OffsetProjectPage",
    path: "/dashboard/marketplace/:id()",
    meta: _91id_93P4gYCzFUk1Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/marketplace/[id].vue").then(m => m.default || m)
  },
  {
    name: "CarbonMarketplacePage",
    path: "/dashboard/marketplace",
    meta: indexraEEiSwSdwMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/marketplace/index.vue").then(m => m.default || m)
  },
  {
    name: "GenerateReportingFrameworksPage",
    path: "/dashboard/reporting-frameworks",
    meta: reporting_45frameworksSxAcwtOi1IMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/reporting-frameworks.vue").then(m => m.default || m)
  },
  {
    name: "ReportGeneratorPage",
    path: "/dashboard/reporting/amoq",
    meta: indexrdCZuC8VhSMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/reporting/amoq/index.vue").then(m => m.default || m)
  },
  {
    name: "GeneratedReportPage",
    path: "/dashboard/reporting/generated-report",
    meta: generated_45reportXyqBNrsQGtMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/reporting/generated-report.vue").then(m => m.default || m)
  },
  {
    name: "GeneratedReportingFramework",
    path: "/dashboard/reporting/preview-report",
    meta: preview_45reportApE0Wuncn3Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/reporting/preview-report.vue").then(m => m.default || m)
  },
  {
    name: "GenerateQuantitativeReportsPage",
    path: "/dashboard/reporting/quantitative-report",
    meta: quantitative_45reportQ51W2N1t8YMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/reporting/quantitative-report.vue").then(m => m.default || m)
  },
  {
    name: "ReportingFrameworksSelectionPage",
    path: "/dashboard/reporting/report-frameworks",
    meta: report_45frameworksTM8PuL6pX3Meta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/reporting/report-frameworks.vue").then(m => m.default || m)
  },
  {
    name: "SettingsGeneralPage",
    path: "/dashboard/settings/general",
    meta: generalN7LZbOvM3OMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/settings/general.vue").then(m => m.default || m)
  },
  {
    name: "IntegrationPage",
    path: "/dashboard/settings/integration",
    meta: integration4fxeNo44TmMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/settings/integration.vue").then(m => m.default || m)
  },
  {
    name: "ManageUsersPage",
    path: "/dashboard/settings/manage-users",
    meta: manage_45usersfuUxdFZZvtMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/settings/manage-users.vue").then(m => m.default || m)
  },
  {
    name: "SettingsPermissionsPage",
    path: "/dashboard/settings/permissions",
    meta: permissions66pR2FTQluMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/settings/permissions.vue").then(m => m.default || m)
  },
  {
    name: "SettingsTierPage",
    path: "/dashboard/settings/tier",
    meta: tierK2pGswoKevMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/settings/tier.vue").then(m => m.default || m)
  },
  {
    name: "CompanyUsersPage",
    path: "/dashboard/settings/users",
    meta: usersZbhdcQPQnYMeta || {},
    component: () => import("/vercel/path0/v3/pages/dashboard/settings/users.vue").then(m => m.default || m)
  },
  {
    name: "DataHandlingPage",
    path: "/data-handling",
    meta: data_45handlingPU0rJFGBDNMeta || {},
    component: () => import("/vercel/path0/v3/pages/data-handling.vue").then(m => m.default || m)
  },
  {
    name: "ErrorPermission",
    path: "/errors/ErrorPermission",
    meta: ErrorPermissionxjDvMeisRdMeta || {},
    component: () => import("/vercel/path0/v3/pages/errors/ErrorPermission.vue").then(m => m.default || m)
  },
  {
    name: "errors-ErrorSubscription",
    path: "/errors/ErrorSubscription",
    component: () => import("/vercel/path0/v3/pages/errors/ErrorSubscription.vue").then(m => m.default || m)
  },
  {
    name: "ErrorSubscriptionExpired",
    path: "/errors/ErrorSubscriptionExpired",
    meta: ErrorSubscriptionExpiredwc2pY2pCFVMeta || {},
    component: () => import("/vercel/path0/v3/pages/errors/ErrorSubscriptionExpired.vue").then(m => m.default || m)
  },
  {
    name: "HomePage",
    path: "/",
    meta: indexsTUPWspFUNMeta || {},
    component: () => import("/vercel/path0/v3/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "RegisterPage",
    path: "/invitations/accept-invite/:key()",
    meta: _91key_93XGxWxXJqiUMeta || {},
    component: () => import("/vercel/path0/v3/pages/invitations/accept-invite/[key].vue").then(m => m.default || m)
  },
  {
    name: "LoginPage",
    path: "/login-old",
    meta: login_45oldSghTZIsvWpMeta || {},
    component: () => import("/vercel/path0/v3/pages/login-old.vue").then(m => m.default || m)
  },
  {
    name: "AccessPage",
    path: "/login",
    meta: loginxY1wJnEVbEMeta || {},
    component: () => import("/vercel/path0/v3/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "AccessNotFound",
    path: "/not-found",
    meta: not_45foundT1JIqJqwiTMeta || {},
    component: () => import("/vercel/path0/v3/pages/not-found.vue").then(m => m.default || m)
  },
  {
    name: "ForgotPasswordPage",
    path: "/password/forgot",
    meta: forgotU1PkwIZ0d0Meta || {},
    component: () => import("/vercel/path0/v3/pages/password/forgot.vue").then(m => m.default || m)
  },
  {
    name: "RegisterPage",
    path: "/register_old",
    meta: register_oldAnPfsBZWdaMeta || {},
    component: () => import("/vercel/path0/v3/pages/register_old.vue").then(m => m.default || m)
  },
  {
    name: "RegisterPage",
    path: "/register",
    meta: registerGuBNcVABfCMeta || {},
    component: () => import("/vercel/path0/v3/pages/register.vue").then(m => m.default || m)
  },
  {
    name: "ReportingFrameworksGeneratePage",
    path: "/reports/generate/:id()",
    meta: _91id_93TOiWmtN4CFMeta || {},
    component: () => import("/vercel/path0/v3/pages/reports/generate/[id].vue").then(m => m.default || m)
  },
  {
    name: "ReportingFrameworksViewPage",
    path: "/reports/view/:id()",
    meta: _91id_932TToJAzhc8Meta || {},
    component: () => import("/vercel/path0/v3/pages/reports/view/[id].vue").then(m => m.default || m)
  },
  {
    name: "ResetPasswordPage",
    path: "/reset/:uid()/:token()",
    meta: _91token_93ATDY3sFNNuMeta || {},
    component: () => import("/vercel/path0/v3/pages/reset/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: "SuccessPage",
    path: "/success",
    meta: successYtwd5j2c6gMeta || {},
    component: () => import("/vercel/path0/v3/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "SuperAdminHome",
    path: "/superadmin/home",
    meta: index46miWyRjCWMeta || {},
    component: () => import("/vercel/path0/v3/pages/superadmin/home/index.vue").then(m => m.default || m)
  },
  {
    name: "CreateTierPage",
    path: "/superadmin/tiers/create",
    meta: createh6XM8uvMF6Meta || {},
    component: () => import("/vercel/path0/v3/pages/superadmin/tiers/create.vue").then(m => m.default || m)
  },
  {
    name: "EditTierPage",
    path: "/superadmin/tiers/edit/:id()",
    meta: _91id_93DuGBqi6nBaMeta || {},
    component: () => import("/vercel/path0/v3/pages/superadmin/tiers/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "TiersPage",
    path: "/superadmin/tiers",
    meta: indexrnD6xX9RrJMeta || {},
    component: () => import("/vercel/path0/v3/pages/superadmin/tiers/index.vue").then(m => m.default || m)
  },
  {
    name: "EditTrialsPage",
    path: "/superadmin/trials/edit/:id()",
    meta: _91id_93qrR9epJd6lMeta || {},
    component: () => import("/vercel/path0/v3/pages/superadmin/trials/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: "TrialsPage",
    path: "/superadmin/trials",
    meta: indexcYZPvTIQuLMeta || {},
    component: () => import("/vercel/path0/v3/pages/superadmin/trials/index.vue").then(m => m.default || m)
  },
  {
    name: "ErrorSubscription",
    path: "/verification-pending",
    meta: verification_45pendingUoHZUEltcpMeta || {},
    component: () => import("/vercel/path0/v3/pages/verification-pending.vue").then(m => m.default || m)
  }
]